import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import zh from './config/zh'
import en from './config/en'
import { getLocale } from '@/utils/auth'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: getLocale(),
  messages: {
    zh, // 中文
    en // 英文
  }
})
locale.i18n((key, value) => i18n.t(key, value))

export default i18n
